import React from 'react'
import {
  Button,
  IconSignPlus
} from '@Knowledge-OTP/znk-ui-components'

const NewActionButton = ({ label, onClick, className = '', style = {}, endIcon = null }) => (
  <Button
    className={`new-action-button ${className} zkn-btn znk-size-small users-action-button py-0 px-2 btn btn-primary`.trim()}
    color='primary'
    size='small'
    style={{ borderRadius: '25px', padding: '2px', width: '130px', ...style }}
    label={(
      <span
        className='d-flex align-items-center p-2'
        style={{ fontSize: '13px' }}
      >
        <span
          className='d-inline-flex align-items-center justify-content-center mr-2 bg-white rounded-circle '
          style={{ width: '12px', height: '12px' }}
        >
          <IconSignPlus size={12} color='white' backgroundColor='#696CFF' />
        </span>
        {label}
        {endIcon && <span className='ml-2'>{endIcon}</span>}
      </span>
    )}
    onClick={onClick}
  />
)

export default NewActionButton
